<template>
  <div class="row" ref="formulario">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter" v-if="isIndex()">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-md-auto">
                <label>Tipo de Captura *</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select required-typeScale shadow-sm"
                  size="large"
                  v-model="model.typeCatch"
                  placeholder="Tipo de Captura..."
                  @change="(showTable = false), uploadRemove"
                >
                  <el-option
                    v-for="option in listTypeCatch"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto">
                <label v-if="model.typeCatch != 3">Fecha del Registro*</label>
                <label v-else>Fecha de Consulta*</label>
                <br />
                <el-date-picker
                  v-model="model.date"
                  @change="(showTable = false), uploadRemove"
                  class="shadow-sm"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  align="right"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  placeholder="Fecha..."
                >
                </el-date-picker>
              </div>
              <div class="col-md-auto" v-if="model.typeCatch == 1">
                <label>Pluviómetro *</label>
                <br />
                <el-select
                  id="listRainAccumulator"
                  filterable
                  class="select-primary custom-width-select required-typeScale shadow-sm"
                  size="large"
                  v-model="model.rainAccumulator"
                  placeholder="Pluviómetro..."
                  @change="uploadRemove"
                >
                  <el-option
                    v-for="option in listRainAccumulator"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />

                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  style="margin-right: 10px"
                  @click="validateFilter"
                >
                  Generar
                </l-button>
              </div>
              <div class="col-md-auto" v-if="showTable && saveType == 2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button
                  wide
                  type="danger"
                  class="btn-filter"
                  style="margin-right: 10px"
                  @click="handleDelete"
                >
                  Eliminar
                </l-button>
              </div>
              <div class="col-md-auto">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button
                  wide
                  type="warning"
                  class="btn-filter"
                  style="margin-right: 10px"
                  @click="downloadFormat"
                >
                  Descargar Formato
                </l-button>
              </div>
              <div class="col-md-auto">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  action="#"
                  :auto-upload="false"
                  :multiple="false"
                  :limit="1"
                  accept=".xls, .xlsx"
                  :on-change="uploadChange"
                  :on-remove="uploadRemove"
                  :on-exceed="uploadExceed"
                  style="display: flex"
                >
                  <l-button wide type="primary" class="btn-filter">
                    Subir Formato
                  </l-button>
                </el-upload>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <template v-if="showTable">
          <div class="row">
            <div class="col-sm-12">
              <el-table
                v-if="model.typeCatch == 1"
                stripe
                max-height="500"
                style="width: 100%"
                :data="tableData"
                :border="true"
              >
                <el-table-column
                  v-for="(column, index) in tableColumns"
                  :key="index"
                  :prop="column.prop"
                  :label="column.label"
                  align="center"
                  :sortable="false"
                  :min-width="column.minWidth"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <template v-if="column.prop == 'start_time'">
                      <el-time-picker
                        :class="'start_time_' + props.$index"
                        v-model="tableData[props.$index].start_time"
                        format="HH:mm:ss"
                        value-format="HH:mm:ss"
                        placeholder="Formato hh:mm:ss 24 Horas"
                        :clearable="false"
                      />
                    </template>
                    <template v-if="column.prop == 'end_time'">
                      <el-time-picker
                        :class="'end_time_' + props.$index"
                        v-model="tableData[props.$index].end_time"
                        format="HH:mm:ss"
                        value-format="HH:mm:ss"
                        placeholder="Formato hh:mm:ss 24 Horas"
                        :clearable="false"
                      />
                    </template>
                    <template v-if="column.prop == 'value'">
                      <el-input
                        :class="'value_' + props.$index"
                        type="text"
                        v-model="tableData[props.$index].value"
                        @input="decimal(props.$index, 'value')"
                        name="value"
                        placeholder="Valor"
                        maxlength="6"
                        style="text-align: center"
                      />
                    </template>
                    <template v-if="column.prop == 'observations'">
                      <el-input
                        :class="'observations_' + props.$index"
                        type="text"
                        v-model="tableData[props.$index].observations"
                        name="observations"
                        placeholder="Observación"
                        maxlength="100"
                      />
                    </template>
                    <template v-if="column.prop == 'options'">
                      <button
                        @click="deleteRow(props.$index, 1)"
                        style="border: none; background: none"
                        v-if="tableData.length > 1"
                      >
                        <i
                          class="fa fa-times"
                          style="color: red; font-size: 18px"
                          v-tooltip.top-center="'Eliminar'"
                        ></i>
                      </button>
                      <button
                        @click="addRow(1)"
                        style="border: none; background: none"
                      >
                        <i
                          class="fa fa-plus"
                          style="color: #4f8949; font-size: 18px"
                          v-tooltip.top-center="'Agregar'"
                        ></i>
                      </button>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                v-if="model.typeCatch == 2 || model.typeCatch == 3"
                stripe
                max-height="500"
                style="width: 100%"
                :data="tableData"
                :border="true"
              >
                <el-table-column
                  v-for="(column, index) in tableColumns"
                  :key="index"
                  :prop="column.prop"
                  :label="column.label"
                  align="center"
                  :sortable="false"
                  :min-width="column.minWidth"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <template
                      v-if="column.prop == 'date' && model.typeCatch == 3"
                    >
                      <el-date-picker
                        v-model="tableData[props.$index].date"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        align="right"
                        :clearable="false"
                        placeholder="Fecha..."
                        :class="'date_' + props.$index"
                        :picker-options="pickerOptions"
                      >
                      </el-date-picker>
                    </template>
                    <template v-if="column.prop == 'rainAccumulator'">
                      <el-select
                        filterable
                        :class="
                          'select-primary custom-width-select shadow-sm rainAccumulator_' +
                          props.$index
                        "
                        size="large"
                        v-model="tableData[props.$index].rainAccumulator"
                        placeholder="Pluviómetro..."
                      >
                        <el-option
                          v-for="option in listRainAccumulator"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-if="column.prop == 'start_time'">
                      <el-time-picker
                        :class="'start_time_' + props.$index"
                        v-model="tableData[props.$index].start_time"
                        format="HH:mm:ss"
                        value-format="HH:mm:ss"
                        placeholder="Formato hh:mm:ss 24 Horas"
                        :clearable="false"
                      />
                    </template>
                    <template v-if="column.prop == 'end_time'">
                      <el-time-picker
                        :class="'end_time_' + props.$index"
                        v-model="tableData[props.$index].end_time"
                        format="HH:mm:ss"
                        value-format="HH:mm:ss"
                        placeholder="Formato hh:mm:ss 24 Horas"
                        :clearable="false"
                      />
                    </template>
                    <template v-if="column.prop == 'value'">
                      <el-input
                        :class="'value_' + props.$index"
                        type="text"
                        v-model="tableData[props.$index].value"
                        @input="decimal(props.$index, 'value')"
                        name="value"
                        placeholder="Valor"
                        maxlength="6"
                        style="text-align: center"
                      />
                    </template>
                    <template v-if="column.prop == 'observations'">
                      <el-input
                        :class="'observations_' + props.$index"
                        type="text"
                        v-model="tableData[props.$index].observations"
                        name="observations"
                        placeholder="Observación"
                        maxlength="100"
                      />
                    </template>
                    <template v-if="column.prop == 'options'">
                      <button
                        @click="deleteRow(props.$index, 2)"
                        style="border: none; background: none"
                        v-if="tableData.length > 1"
                      >
                        <i
                          class="fa fa-times"
                          style="color: red; font-size: 18px"
                          v-tooltip.top-center="'Eliminar'"
                        ></i>
                      </button>
                      <button
                        @click="addRow(3)"
                        style="border: none; background: none"
                      >
                        <i
                          class="fa fa-plus"
                          style="color: #4f8949; font-size: 18px"
                          v-tooltip.top-center="'Agregar'"
                        ></i>
                      </button>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12" v-if="isCreate() || isUpdate()">
              <div class="text-center">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="validate"
                >
                  <i class="fa fa-save"></i>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </template>
      </card>
      <div v-else>
        <br />
        <h5 class="text-muted text-center">
          {{ $t('common_words.no_permissions') }}
        </h5>
      </div>
    </div>
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinNotification } from 'src/mixins/mixin-notification';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import store from '@/store';

export default {
  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinMenu,
    MixinNotification,
    MixinValidations,
    MixinExport,
  ],
  data() {
    return {
      model: {
        typeCatch: 1,
        rainAccumulator: null,
        date: this.formatDate(new Date()),
      },
      activeName: '1',
      saveType: null,
      showTable: false,
      listRainAccumulator: [],
      showNotificationAdd: false,
      showNotificationAddMsj: null,
      listTypeCatch: [
        { id: 1, name: 'Pluviómetro' },
        { id: 2, name: 'Horas' },
        { id: 3, name: 'Dias' },
      ],
      tableData: [],
      tableColumns: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleDelete() {
      SweetAlert.delete(`Registro`).then((result) => {
        if (result.value) this.delete();
      });
    },
    delete() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        let param = {
          route: 'devices/catchrainaccumulators/delete',
          typeCatch: this.model.typeCatch,
        };
        switch (this.model.typeCatch) {
          case 1:
            param.id = this.tableData[0].id;
            param.id2 = this.tableData[0].id2;
            break;
          case 2:
            param.id = this.tableData[0].id;
            break;
          case 3:
            param.date = this.model.date;
            break;
        }
        Axios.postMasters(param)
          .then((response) => {
            this.showTable = false;
            this.showHideLoading();
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-simple-add',
              'Exitoso...'
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },
    downloadFormat() {
      let data = {};
      data.route = 'devices/catchrainaccumulators/downloadformat';
      data.name_file = 'catchrainaccumulators.xlsx';
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    uploadChange(response, file) {
      if (
        response.raw.type ==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        response.raw.type == 'application/vnd.ms-excel'
      ) {
        this.viewFile(response.raw);
      } else {
        this.$refs.upload.clearFiles();
        let msg =
          'Archivo Invalido, solo se puede subir archivos con extensión .xls o .xlsx';
        this.showNotification(msg, 'warning', 'nc-simple-add', 'Aviso...');
      }
    },
    uploadRemove() {
      this.showTable = false;
      this.$refs.upload.clearFiles();
    },
    uploadExceed(files, fileList) {
      let msg = 'Se excedió el número máximo de archivos excel permitidos.';
      this.showNotification(msg, 'warning', 'nc-simple-add', 'Aviso...');
    },
    viewFile(file) {
      this.showHideLoading(true);
      this.showTable = false;
      var data = new FormData();
      data.append('file', file);
      Axios.uploadMaster(
        'auth/devices/catchrainaccumulators/uploadformat',
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      )
        .then((response) => {
          let responseData = response.data;
          this.model.date = responseData.date;
          this.model.typeCatch = 3;
          this.tableColumns = responseData.tableColumns;
          this.tableData = responseData.tableData;
          this.saveType = responseData.saveType;
          this.showTable = true;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
          this.uploadRemove();
        });
    },
    formatDate(date) {
      var date = new Date(date);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    setCurrentTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    },
    isTimeRangeOverlap(date1, start1, end1, date2, start2, end2) {
      const startTime1 = new Date(`${date1}T${start1}`);
      const endTime1 = new Date(`${date1}T${end1}`);
      const startTime2 = new Date(`${date2}T${start2}`);
      const endTime2 = new Date(`${date2}T${end2}`);
      return startTime1 < endTime2 && endTime1 > startTime2;
    },
    decimal(i, key) {
      let exp_val = /^(\d)?(\d)*\.?\d*$/;
      if (!exp_val.test(this.tableData[i][key])) {
        this.$set(this.tableData[i], key, this.oldValue);
      } else {
        this.oldValue = this.tableData[i][key];
      }
    },
    async validateFilter() {
      return this.$validator.validateAll().then((isValid) => {
        if (!this.model.rainAccumulator && this.model.typeCatch == 1) {
          let sel = document.getElementById('listRainAccumulator');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (isValid) this.getDataTable();
      });
    },
    validate() {
      let band = true;
      let showNotification = true;
      let duplicates = [];
      let keys = [];
      let ranges = [];
      this.tableData.forEach((row, index) => {
        let start_time = document.querySelector(
          `.start_time_${index} input`
        ).value;
        let end_time = document.querySelector(`.end_time_${index} input`).value;
        if (this.model.typeCatch == 3) {
          keys.push(
            `${row.date}_${row.rainAccumulator}_${start_time}_${end_time}`
          );
          ranges.push({ date: row.date, start_time, end_time });
        } else {
          ranges.push({ start_time, end_time });
        }
        if (this.model.typeCatch == 2) {
          keys.push(`${row.rainAccumulator}_${start_time}_${end_time}`);
        }
        if (!row.value) {
          band = false;
          if (showNotification) {
            this.showNotification(
              'Verifique los datos ingresados...',
              'danger',
              'nc-simple-remove',
              'Aviso...'
            );
            showNotification = false;
          }
          let sel = document.querySelector(`.value_${index} input`);
          sel.classList.add('custom-has-error');
          setTimeout(() => {
            sel.classList.remove('custom-has-error');
          }, 5000);
        }
      });
      if (band) {
        const tempArray = [...keys].sort();
        for (let i = 0; i < tempArray.length; i++) {
          if (tempArray[i + 1] === tempArray[i]) {
            duplicates.push(tempArray[i]);
          }
        }
        if (duplicates.length > 0) {
          band = false;
          let id = null;
          for (const key in duplicates) {
            this.tableData.forEach((row, i) => {
              let start_time = document.querySelector(`.start_time_${i} input`);
              let end_time = document.querySelector(`.end_time_${i} input`);
              let recordKey = null;
              if (this.model.typeCatch == 2) {
                recordKey = `${row.rainAccumulator}_${start_time.value}_${end_time.value}`;
              } else if (this.model.typeCatch == 3) {
                recordKey = `${row.date}_${row.rainAccumulator}_${start_time.value}_${end_time.value}`;
              }
              if (recordKey == duplicates[key]) {
                let date = null;
                let rainAccumulator = document.querySelector(
                  `.rainAccumulator_${i} input`
                );
                if (this.model.typeCatch == 3)
                  date = document.querySelector(`.date_${i} input`);
                if (id != duplicates[key]) {
                  setTimeout(() => {
                    this.showNotification(
                      `El registro se encuentra duplicado`,
                      'danger',
                      'nc-simple-remove',
                      'Aviso...'
                    );
                  }, i * 10);
                }
                id = duplicates[key];
                if (this.model.typeCatch == 3)
                  date.classList.add('custom-has-error');
                rainAccumulator.classList.add('custom-has-error');
                start_time.classList.add('custom-has-error');
                end_time.classList.add('custom-has-error');
                setTimeout(() => {
                  if (this.model.typeCatch == 3)
                    date.classList.remove('custom-has-error');
                  rainAccumulator.classList.remove('custom-has-error');
                  start_time.classList.remove('custom-has-error');
                  end_time.classList.remove('custom-has-error');
                }, 5000);
              }
            });
          }
        }
        if (ranges.length > 0 && band) {
          for (let i = 0; i < ranges.length; i++) {
            for (let j = i + 1; j < ranges.length; j++) {
              let date1 =
                this.model.typeCatch != 3 ? '1970-01-01' : ranges[i].date;
              let date2 =
                this.model.typeCatch != 3 ? '1970-01-01' : ranges[j].date;
              if (
                this.isTimeRangeOverlap(
                  date1,
                  ranges[i].start_time,
                  ranges[i].end_time,
                  date2,
                  ranges[j].start_time,
                  ranges[j].end_time
                )
              ) {
                console.log(ranges);
                let date = null;
                if (this.model.typeCatch == 3) {
                  date = document.querySelector(`.date_${i} input`);
                  date2 = document.querySelector(`.date_${j} input`);
                }
                let start_time = document.querySelector(
                  `.start_time_${i} input`
                );
                let end_time = document.querySelector(`.end_time_${i} input`);
                let start_time2 = document.querySelector(
                  `.start_time_${j} input`
                );
                let end_time2 = document.querySelector(`.end_time_${j} input`);
                if (this.model.typeCatch == 3) {
                  date.classList.add('custom-has-error');
                  date2.classList.add('custom-has-error');
                }
                start_time.classList.add('custom-has-error');
                end_time.classList.add('custom-has-error');
                start_time2.classList.add('custom-has-error');
                end_time2.classList.add('custom-has-error');
                setTimeout(() => {
                  if (this.model.typeCatch == 3) {
                    date.classList.remove('custom-has-error');
                    date2.classList.remove('custom-has-error');
                  }
                  start_time.classList.remove('custom-has-error');
                  end_time.classList.remove('custom-has-error');
                  start_time2.classList.remove('custom-has-error');
                  end_time2.classList.remove('custom-has-error');
                }, 5000);
                if (showNotification) {
                  this.showNotification(
                    'Verifique los rangos de hora ingresados...',
                    'danger',
                    'nc-simple-remove',
                    'Aviso...'
                  );
                  showNotification = false;
                }
                band = false;
              }
            }
          }
        }
      }
      if (band) this.savedData();
    },
    savedData() {
      if (this.isCreate() || this.isUpdate()) {
        this.showHideLoading(true);
        this.model.route = 'devices/catchrainaccumulators';
        this.model.tableData = this.tableData;
        this.model.id = this.tableData[0].id ? this.tableData[0].id : null;
        const request =
          this.saveType == 1
            ? Axios.saveMaster(this.model)
            : Axios.updateMaster(this.model);
        request
          .then((response) => {
            let responseData = response.data.data;
            this.tableColumns = responseData.tableColumns;
            this.tableData = responseData.tableData;
            this.saveType = responseData.saveType;
            this.showTable = true;
            this.showHideLoading();
            this.uploadRemove();
            this.showNotificationAdd = true;
            this.showNotificationAddMsj = response.data.message;
            this.getDataTable();
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },
    getDataTable() {
      this.showHideLoading(true);
      this.showTable = false;
      let data = {
        route: 'devices/catchrainaccumulators/getdatatable',
        typeCatch: this.model.typeCatch,
        date: this.model.date,
        rainAccumulator:
          this.model.typeCatch == 1 ? this.model.rainAccumulator : null,
      };
      Axios.postMasters(data)
        .then((response) => {
          let responseData = response.data;
          this.tableColumns = responseData.tableColumns;
          this.tableData = responseData.tableData;
          this.saveType = responseData.saveType;
          this.showTable = true;
          this.showHideLoading();
          if (this.showNotificationAdd) {
            this.showNotification(
              this.showNotificationAddMsj,
              'success',
              'nc-simple-add',
              'Exitoso...'
            );
            this.showNotificationAdd = false;
          }
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
    addRow(type) {
      if (type == 1) {
        this.tableData.push({
          start_time: '00:00:00',
          end_time: '23:00:00',
          value: null,
          observations: null,
        });
      } else if (type == 2) {
        this.tableData.push({
          rainAccumulator: this.listRainAccumulator[0].id,
          start_time: '00:00:00',
          end_time: '23:00:00',
          value: null,
          observations: null,
        });
      } else {
        this.tableData.push({
          date: this.formatDate(new Date()),
          rainAccumulator: this.listRainAccumulator[0].id,
          start_time: '00:00:00',
          end_time: '23:00:00',
          value: null,
          observations: null,
        });
      }
    },
    deleteRow(index, type) {
      if (type == 1) {
        this.tableData.splice(index, 1);
      } else {
        this.tableData.splice(index, 1);
      }
    },
  },
  created() {
    this.showHideLoading(true);
    Axios.getMasters('devices/catchrainaccumulators/getselectinfo')
      .then((response) => {
        let responseData = response.data;
        this.listRainAccumulator = responseData.listRainAccumulator;
        if (this.listRainAccumulator.length > 0)
          this.model.rainAccumulator = this.listRainAccumulator[0].id;
        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        this.showMessageErrors(error);
      });
  },
  mounted() {
    this.selectedItemOnMenu('devices');
  },

  destroyed() {
    this.deselectedItemOnMenu('devices');
  },
};
</script>
<style >
.el-input .el-input__inner:focus {
  outline: 0 !important;
  border-color: #6ba652 !important;
}
</style>